<template>
  <v-row>
    <v-col cols="12" :md="8" :sm="7">
      <PageTitle :title="titleAbout" />
      <PresentationAboutCourse :isCourseAdmin="isCourseAdmin" />
      <HoleAboutCourseEdit
        v-if="isEditHole"
        @editHoleTable="editHoleTable"
        :isCourseAdmin="isCourseAdmin"
      />
      <HoleAboutCourse
        v-else
        @editHoleTable="editHoleTable"
        :isCourseAdmin="isCourseAdmin"
      />
      <div
        class="d-flex align-center justify-space-between mt-md-8 my-3"
        v-if="course && course.name"
      >
        <h2 class="text-md-h6 text-subtitle-1 font-weight-bold">
          <translate>The Golf courses at</translate> {{ course.name }}
        </h2>
      </div>
      <div v-if="coursePeers.length !== 0">
        <TableAboutCourse
          class="mb-8"
          v-for="data in coursePeers"
          :key="data.id"
          :data="data"
          :isCourseAdmin="isCourseAdmin"
        />
      </div>
    </v-col>
    <v-col cols="12" :md="4" :sm="5">
      <DrawerRight />
    </v-col>
  </v-row>
</template>

<script>
import DrawerRight from "@/components/DrawerRight";
import PageTitle from "@/components/PageTitle";
import ButtonEdit from "@/components/Buttons/ButtonEdit";
import TableAboutCourse from "@/components/Courses/TableAboutCourse";
import HoleAboutCourse from "@/components/Courses/HoleAboutCourse";
import HoleAboutCourseEdit from "@/components/Courses/HoleAboutCourseEdit";
import PresentationAboutCourse from "@/components/Courses/PresentationAboutCourse";

export default {
  name: "CoursesAbout",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        },
      ],
    };
  },
  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  components: {
    DrawerRight,
    PageTitle,
    ButtonEdit,
    TableAboutCourse,
    HoleAboutCourse,
    HoleAboutCourseEdit,
    PresentationAboutCourse,
  },
  data() {
    return {
      isEditHole: false,
      coursePeers: [],
      isMobile: false
    };
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    titleAbout() {
      return this.$gettextInterpolate(this.$gettext("Presentation of %{name}"),{name: this.course.name})
    },
    metaTitle() {
      const binder = {
        courseName: (this.course && this.course.name) ? this.course.name : "",
      }
      const translated = this.$gettext("%{courseName} - About the golf Courses");
      return this.$gettextInterpolate(translated, binder);
    },
    metaDescription() {
      const binder = {
        courseName: this.course && this.course.name ? this.course.name : "",
        countryName:
          this.course && this.course.country.name
            ? this.course.country.name
            : "",
      }
      const translated = this.$gettext("About %{courseName} golf courses  in %{countryName}, Discover everything about %{courseName} Golf courses. Check all the Golf courses information at %{courseName}");
      return this.$gettextInterpolate(translated, binder);
    },
  },
  methods: {
    editHoleTable() {
      this.isEditHole = !this.isEditHole;
    },

    divArray(array, number) {
      return Array(Math.ceil(array.length/number)).fill().map(function(_,i){
            return array.slice(i*number,i*number+number);
        });
    },
    onResize () {
        this.isMobile = window.innerWidth < 992;
        let coursePeers = this.course.coursePeers
        if(coursePeers)this.coursePeers = this.divArray(coursePeers, this.isMobile ? 1 : 4)
        else return
    },

  },
  mounted () {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window === 'undefined') return;
    window.removeEventListener('resize', this.onResize, { passive: true })
  },
};
</script>
